import { Pipe, PipeTransform } from '@angular/core';
import { EntitlementModel } from '../models/entitlement.model';
import { TranslatePipe } from './translate.pipe';
import getAddOnNames from '../utils/string/getAddonNames';

/**
 * Transform Entitlements object to the string contains
 * Product names and Addons in specific format.
 * example: 'Product name - Addons: Addon name 1, Addon name 2'
 */
@Pipe({ name: 'productAddonsSRLabel' })
export class ProductAddonsSRLabelPipe implements PipeTransform {
  transform(value: EntitlementModel, translatePipe: TranslatePipe): string {
    let productAddonsLabelText: string = value.productName || '';
    const supplements = value.supplements;

    if (
      supplements &&
      supplements.length > 0 &&
      productAddonsLabelText.length > 0
    ) {
      productAddonsLabelText += ` ${translatePipe.transform(
        'assign-page.addons-label'
      )} ${getAddOnNames(supplements)}`;
    }

    return productAddonsLabelText;
  }
}
